import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';

import {
  ClearButton,
  SelectDropDown,
  DatePicker
} from 'components/common/Elements/Elements';

import classes from './FiltersBlock.module.scss';

const FiltersBlock = ({
  filter,
  setFilter,
  startFilter,
  setStartFilter,
  sentimentFilters,
  selectLoader,
  resetAllfilters,
  filterButton,
  setVisibleFilterSave,
  setVisibleFilterEdit,
  changeFilter,
  trigerResetDatePicker
}) => {
  const { t } = useTranslation(['activity']);

  const numberОfFilters = 3;

  const handleFilter = e => {
    setFilter({ ...filter, [e.target]: e.value, currentPage: 1 });
    setVisibleFilterSave('button');
    if (changeFilter !== 'Default') {
      setVisibleFilterEdit(true);
    }
  };

  const handleDateChange = value => {
    const key = 'sentimentDate';
    checkAndSetFilter(key, value);
  };

  function checkAndSetFilter(key, value) {
    if (!isEqual(filter[key], value)) {
      setFilter({ ...filter, [key]: value, currentPage: 1 });
      setStartFilter(!startFilter);
      setVisibleFilterSave('button');
      if (changeFilter !== 'Default') {
        setVisibleFilterEdit(true);
      }
    }
  }

  return (
    <div className={cn(filterButton ? classes.filters : classes.filters_close)}>
      <DatePicker
        label={t('activity:filters.SENTIMENT_DATE')}
        input={{
          value: filter.sentimentDate,
          onChange: handleDateChange
        }}
        trigerResetDatePicker={trigerResetDatePicker}
      />
      <SelectDropDown
        options={sentimentFilters.accountManager}
        input={{ value: filter.accountManager, onChange: handleFilter }}
        name={'accountManager'}
        label={t('activity:filters.ACC_MANAGER')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={sentimentFilters.sentiment}
        input={{ value: filter.sentiment, onChange: handleFilter }}
        name={'sentiment'}
        label={t('activity:filters.SENTIMENT')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <ClearButton
        onClick={() => resetAllfilters(false, true, false, true)}
        numberОfFilters={numberОfFilters}
      />
    </div>
  );
};

FiltersBlock.propTypes = {
  filter: PropTypes.object,
  setFilter: PropTypes.func,
  startFilter: PropTypes.bool,
  setStartFilter: PropTypes.func,
  filterButton: PropTypes.bool,
  sentimentFilters: PropTypes.object,
  selectLoader: PropTypes.bool,
  trigerResetDatePicker: PropTypes.bool,
  resetAllfilters: PropTypes.func,
  setVisibleFilterSave: PropTypes.func,
  setVisibleFilterEdit: PropTypes.func,
  changeFilter: PropTypes.string
};

export default FiltersBlock;
